<template>
  <q-page class="flex flex-center" style="min-height: 100vh">
    <q-card class="login-card q-pa-lg" style="width: 100%; max-width: 420px">
      <q-card-section class="text-center q-mb-md">
        <img :src="asupcaLogo" alt="ASUPCA" style="height: 72px; width: auto; display: inline-block; margin-bottom: 4px;" />
        <p style="margin: 0; font-size: 15px; font-weight: 500; line-height: 1.35; color: var(--oa-text-secondary);">Asociación de Stand Up Paddle<br />de la Costa Atlántica</p>
      </q-card-section>

      <q-card-section>
        <p class="text-oa-secondary text-center q-mb-md" style="margin-top: 0; padding-bottom: 10px;">Iniciá sesión en tu cuenta</p>

        <q-banner
          v-if="error"
          class="bg-negative text-white q-mb-md"
          rounded
          dense
        >
          {{ error }}
        </q-banner>

        <q-form @submit.prevent="onSubmit" class="q-gutter-md">
          <q-input
            v-model="email"
            type="email"
            label="Email"
            outlined
            :rules="[
              (val: string) => !!val || 'El email es obligatorio',
              (val: string) => /.+@.+\..+/.test(val) || 'Email inválido',
            ]"
            lazy-rules
          >
            <template #prepend>
              <q-icon name="email" />
            </template>
          </q-input>

          <q-input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            label="Contraseña"
            outlined
            :rules="[
              (val: string) => !!val || 'La contraseña es obligatoria',
            ]"
            lazy-rules
          >
            <template #prepend>
              <q-icon name="lock" />
            </template>
            <template #append>
              <q-icon
                :name="showPassword ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="showPassword = !showPassword"
              />
            </template>
          </q-input>

          <div>
            <q-btn
              type="submit"
              label="Iniciar sesión"
              color="primary"
              text-color="white"
              class="full-width"
              size="lg"
              :loading="loading"
              :disable="loading"
              no-caps
            />
          </div>
        </q-form>
      </q-card-section>

      <q-card-section class="text-center">
        <p class="text-oa-secondary">
          No tenés cuenta?
          <router-link to="/register" style="text-decoration: none; color: var(--oa-gold-full)">
            Registrate
          </router-link>
        </p>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from 'stores/useAuthStore';
import { AxiosError } from 'axios';
import asupcaLogo from 'src/assets/asupca-logo.png';

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const email = ref('');
const password = ref('');
const showPassword = ref(false);
const loading = ref(false);
const error = ref('');

async function onSubmit() {
  error.value = '';
  loading.value = true;

  try {
    await authStore.login(email.value, password.value);
    const redirect = (route.query.redirect as string) || '/';
    await router.push(redirect);
  } catch (err) {
    if (err instanceof AxiosError && err.response?.data?.message) {
      error.value = err.response.data.message as string;
    } else {
      error.value = 'Error al iniciar sesión. Intentá de nuevo.';
    }
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped lang="scss">
.login-card {
  background: var(--color-white-cap);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-prominent);
  border: none;
  border-top: 3px solid var(--color-ocean-light);
  transition: box-shadow var(--transition-base);
}
</style>
